import React, { PropTypes } from 'react';
// Components
import Profile from './Profile';
import NoData from '../../layout/noData/NoData';
import LoadingContent from '../../layout/loadingContent/LoadingContent';

const propTypes = {
  action: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  profiles: PropTypes.array,
};

const Profiles = (props) => {
  if (props.loading) {
    return <LoadingContent />;
  }

  const profiles = props.profiles.length > 0
    ? (
      props.profiles.map((profile, i) => {
        return <Profile key={i} profile={profile} action={props.action} />;
      })
    )
    : <NoData />
    ;

  return (
    <div className="ui overflow five computer doubling centered cards">
      {profiles}
    </div>
  );
};

Profiles.propTypes = propTypes;

export default Profiles;



/** WEBPACK FOOTER **
 ** ./src/components/layout/profiles/Profiles.js
 **/